import isEmail from 'validator/es/lib/isEmail';
import isEmpty from 'validator/es/lib/isEmpty';
import isURL from 'validator/es/lib/isURL';
import isFloat from 'validator/es/lib/isFloat';
import isInt from 'validator/es/lib/isInt';

export class FormValidationsCollection {

  required(value) {
    return !isEmpty(value);
  }

  maxLength(value, param) {
    return value.length <= param;
  }

  minLength(value, param) {
    return value.length >= param;
  }

  email(value) {
    return isEmail(value);
  }

  url(value) {
    return isURL(value);
  }

  float(value) {
    return isFloat(value);
  }

  integer(value) {
    return isInt(value);
  }
}
